/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color, animations, replacePXinStringWithEM, pxToEmWithBaseline, button, mediaQuery } from 'utils/styles';



/* ++++++++++ --------------- SKIP BUTTON STYLES --------------- ++++++++++ */

export default {
  skip: {
    height: 'fit-content',
    color: '#ececec',
    '& path': {
      fill: '#ececec'
    },
    fontSize: pxToEmWithBaseline({ value: 11, fontSizeBaseline: 12 }),
    lineHeight: '1',
    background: 'transparent',// 'rgba(216, 216, 216, .3)',
    marginBottom: pxToEm(2),
    outline: 'none',
    border: 'none',
    borderRadius: pxToEm(3),
    cursor: 'pointer',
    zIndex: '10',

    // pull off screen to start
    transform: 'translate3d(200%, 0, 0)',
    transition: 'all .2s linear 0s',

    //animation
    animationName: 'fadeInRight',
    animationDelay: '.5s',
    animationDuration: '.4s',
    animationFillMode: 'forwards',

    '& .skipinner': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: pxToEm(5)
    },

    '&:hover': {
      color: '#fff',
      fontWeight: 500,
      '& path': {
        fill: '#fff'
      }
    },

    '& i': {
      marginLeft: pxToEm(5),
      fontSize: pxToEm(12)
    },

    '&.hidden-true': {
      animationName: 'fadeOutRight',
      animationDelay: '.5s',
      animationDuration: '.4s',
      animationFillMode: 'forwards'
    }
  }
};
